import Geocode from "react-geocode";
import {API_KEY} from './constants'

Geocode.setApiKey(API_KEY);
Geocode.setLanguage("en");
Geocode.enableDebug();

const fromLatLng = async (coordinates, cb) => {
  if (!coordinates) return;
  const {lat, lng} = coordinates;
  try {
    const response = await Geocode.fromLatLng(lat, lng);
    cb(response.results[0].formatted_address);
  } catch(err) {
    console.error(err);
  }
}

export {
  Geocode as default,
  fromLatLng
};